import { createSelector } from 'reselect';
import { unlockSnackbarKey } from '../reducers/route';

export const getNotifications = (state) => state.notifications;

export const getNotificationsExceptUnlock = createSelector(
  getNotifications,
  (notifications) =>
    notifications.filter(({ key }) => key !== unlockSnackbarKey)
);
